export default function copyText (str) {
    return new Promise(resolve => {
        navigator.clipboard.writeText(str);

        setTimeout(() => {
            resolve();
        }, 2000);
    });
}